<script setup>
  import { ref, computed, watchEffect } from 'vue';
  import useConfigurationGlobals from '@/composables/useConfigurationGlobals';

  const { $TEMPESTPROVIDERS, $AIBPROVIDERS } = useConfigurationGlobals();

  const props = defineProps({
    spotDataObject: {
      type: Object,
      required: true
    }
  });  

  const caricoosStationIds = [48649, 48687, 48688, 48685, 48650, 48686, 160340, 630468, 602927, 602928, 598460, 151997, 48691, 48694, 48692];

  const sourceMessage = ref(null);
  const sourceMessagePosition = ref('bottom');

  if (caricoosStationIds.indexOf(props.spotDataObject.spotId) > -1) {
    sourceMessage.value = 'Funded by';
    sourceMessagePosition.value = 'top';
  } else {
    sourceMessage.value = props.spotDataObject.station.source_message;
  }

  const sourceLogo = computed(() => {
    const provider = props.spotDataObject.station.provider;
    const message = props.spotDataObject.station.source_message;  

    if (caricoosStationIds.indexOf(props.spotDataObject.spotId) > -1) {
      return {
        websiteLink: 'https://www.caricoos.org/',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-caricoos.png',
        alt: 'Caricoos Logo'
      }
    }

    if (message && message.indexOf('nderground') > -1) {
      return {
        websiteLink: 'https://www.wunderground.com/?apiref=57d4c49097e5b689',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-wunder.png',
        alt: 'Wunderground.com logo'
      }
    }

    if (provider === 1) {
      if (message && message.indexOf('Endless Windz') > -1) {
        return {
          websiteLink: 'http://endlesswindz.com/',
          imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-endless-windz.jpg',
          alt: 'Endless Windz Logo'
        }
      }

      return {
          websiteLink: 'https://www.weatherflow.com/',
          imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-weatherflow-networks.png',
          alt: 'WeatherFlow Network logo'
      }
    }

    if (provider === 335) {
      return {
        websiteLink: 'https://www.iweathar.co.za',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-iweather.jpg',
        alt: 'iWeather Logo'
      }
    }

    if (provider === 338) {
      return {
        websiteLink: 'https://recon.sccf.org',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-sccf.png',
        alt: 'SCCF Recon Logo'
      }
    }

    if (provider === 385) {
      return {
        websiteLink: false, // thewindop.com is no longer online
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-windop.jpg',
        alt: 'The WindOp.com Logo'
      }
    }

    if ($AIBPROVIDERS.indexOf(provider) > -1) {
      return {
        websiteLink: 'https://www.weatherflow.com/',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-nearcast.svg',
        alt: 'WeatherFlow Network logo'
      }
    }    

    if ($TEMPESTPROVIDERS.indexOf(provider) > -1 || props.spotDataObject.station.is_nc_wind) {
      return {
        websiteLink: 'https://got.wf/tempest',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-tempest.svg',
        alt: 'Tempest Network logo'
      }
    }

    if (message && message.indexOf('KiteProvo') > -1) {
      return {
        websiteLink: 'https://kiteprovo.com',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-kite_provo.jpg',
        alt: 'KiteProvo.com logo'
      }
    }

    return {
      websiteLink: false,
      imageSource: false
    }
  })

  const showSourceBlock = computed(() => props.spotDataObject.station.source_message || sourceLogo.value.attributionText);

  watchEffect(() => sourceMessage.value = props.spotDataObject.station.source_message);
</script>

<template>
  <div v-if="showSourceBlock" class="jwx-current-conditions-source">
    <a
      v-if="sourceLogo.websiteLink"
      :href="sourceLogo.websiteLink"
      class="jwx-current-conditions-source__link"
      target="_blank"
    >
      <img :src="sourceLogo.imageSource" :alt="sourceLogo.alt" class="jwx-current-conditions-source__logo">
    </a>
    <img v-else-if="sourceLogo.imageSource" :src="sourceLogo.imageSource" :alt="sourceLogo.alt" class="jwx-current-conditions-source__logo">
    <p
      v-html="sourceMessage"
      class="jwx-current-conditions-source__message"
      :data-position="sourceMessagePosition"
    ></p>
  </div>
</template>